import Button from "@mui/material/Button";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ErrorIcon from '@mui/icons-material/Error';
import { Trans } from 'react-i18next';
import { RunButtonRunning } from "./RunButtonRunning";
import { useAppSelector } from "../../../store/hooks";
import { useEffect, useState } from "react";

type Props = {
    onRun: () => void;
    onStop: () => void;
    pid: string;
}

export const RunButton = ({ onRun, onStop, pid }: Props): JSX.Element => {
    const pipeline = useAppSelector(state => state.pipeline)
    const [buttonColor, setButtonColor] = useState('success' as 'success' | 'error');
    const [buttonIcon, setButtonIcon] = useState(<PlayArrowIcon/>)

    useEffect(() => {
        if(pipeline.error) {
            setButtonColor('error');
            setButtonIcon(<ErrorIcon/>);
        }
        else {
            setButtonColor('success');
            setButtonIcon(<PlayArrowIcon/>);
        }
    }, [pipeline.error])

    if(pipeline.isRunning) {
        return (
            <RunButtonRunning onStop={onStop} pid={pid} ></RunButtonRunning>
        )
    }

    else {
        return (
            <Button variant={'contained'} color={buttonColor} startIcon={buttonIcon} onClick={onRun}>
                <Trans>Run</Trans>
            </Button>
        )
    }
}